export default {"src":"/_next/static/media/loop_logo_short.ab7b6245.svg","height":56,"width":49,"blurWidth":0,"blurHeight":0};